import { FacilityUpdateInput, useFacilityDetailQuery } from '@admin/schema';

export function emptyFacilityFormInput(): FacilityUpdateInput {
  return {
    name: '',
    code: '',
    active: true,
    tz: '',
    regionIDs: [],
    facilityServiceOfferings: [],
    address: {
      aptsuite: '',
      street: '',
      city: '',
      state: '',
      country: 'United States',
      zip: '',
    },
  };
}

export function toFacilityUpdateInput(
  facility: NonNullable<ReturnType<typeof useFacilityDetailQuery>['data']>['facility'],
): FacilityUpdateInput {
  const address = facility.address;

  return {
    name: facility.name,
    code: facility.code,
    active: facility.active,
    tz: facility.tz,
    regionIDs: facility.regions.map((region) => region.id),
    facilityServiceOfferings: facility.serviceOfferings.map((offering) => ({
      facilityServiceTypeID: offering.serviceType.id,
      operator: offering.operator,
    })),
    address: {
      id: address?.id,
      aptsuite: address?.aptsuite || '',
      street: address?.street ?? '',
      city: address?.city ?? '',
      state: address?.state ?? '',
      country: address?.country || 'United States',
      zip: address?.zip ?? '',
      latitude: address?.latitude ?? undefined,
      longitude: address?.longitude ?? undefined,
    },
  };
}
